import React from 'react';
import { Box } from '@mui/material';

const DEFAULT_LOGO = '/logo.png';
const TAGLINE = 'Investments Redefined';

const CompanyLogo = ({
  height = 48,
  showTagline = false,
  src,
  alt = 'Bagalu Properties Ltd',
  sx = {},
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      ...sx,
    }}
  >
    <Box
      component="img"
      src={src || DEFAULT_LOGO}
      alt={alt}
      sx={{
        height,
        width: 'auto',
        maxWidth: showTagline ? 280 : 180,
        objectFit: 'contain',
        display: 'block',
      }}
    />
    {showTagline && (
      <Box
        component="span"
        sx={{
          mt: 0.5,
          color: '#70D1F4',
          fontSize: height > 60 ? '0.95rem' : '0.8rem',
          letterSpacing: '0.02em',
        }}
      >
        {TAGLINE}
      </Box>
    )}
  </Box>
);

export default CompanyLogo;
